import React, { useReducer, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ProductContext } from 'context/Context';
import { productReducer } from 'reducers/productReducer';
import { Spinner } from 'react-bootstrap';
import AppContext from 'context/Context';
import { postToTask } from 'y4/Y4Api';
import y from 'y4/Utils';

const ProductProvider = ({ children }) => {
  const {
    config: { corp }
  } = useContext(AppContext);

  const initData = {
    config: null,
    products: [],
    cartItems: [],
    promo: null,
    favouriteItems: [],
    addressItems: [],
    paymentMethod: null, //selected payment method
    address: null, //selected address
    cartModal: {
      show: false,
      product: {},
      quantity: 0,
      type: 'add'
    },
    addressModal: {
      show: false,
      address: {},
      type: 'add'
    }
  };
  const [productsState, productsDispatch] = useReducer(
    productReducer,
    initData
  );

  const isInShoppingCart = id =>
    !!productsState.cartItems.find(cartItem => cartItem.id === id);
  const isInFavouriteItems = id =>
    !!productsState.favouriteItems.find(
      favouriteItem => favouriteItem.id === id
    );
  useEffect(() => {
    postToTask('TASK_ECommerce_Load_Config', { corp }).then(rt => {
      if (rt.isOk()) {
        productsDispatch({ type: 'CONFIG', payload: { config: rt.data } });
      } else {
        y.toastError(rt.message);
      }
    });
  }, []);
  return (
    <ProductContext.Provider
      value={{
        productsState,
        productsDispatch,
        isInShoppingCart,
        isInFavouriteItems
      }}
    >
      {productsState.config ? children : <Spinner animation="grow" />}
    </ProductContext.Provider>
  );
};

ProductProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ProductProvider;
